import { Component, Input, OnInit } from '@angular/core';
import { Condition, OfbizForm } from '@urbannex/ofbiz-forms';
import { ActionState, BaseComponentConfig, BreadCrumbData, ComponentConfig, MenuTitleOptions, Relation, SelectedValue, UbsComponentStoreService, UpdateComponentStoreService, ViewContainersService, getFields, getIdFieldName, getTargets, getTitleDescriptionField } from '@urbannex/view-containers';
import { ORDR_FORMS } from './forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';

@Component({
  selector: 'ubs-order-info',
  templateUrl: './order-info.component.html',
  styleUrls: ['./order-info.component.scss']
})
export class OrderInfoComponent extends BaseComponentConfig implements OnInit{
  @Input() orderId:string;
  selectedValue:SelectedValue;
  breadCrumbs:BreadCrumbData[];
  hasValue = false;
  options:ComponentConfig = {
    name: 'Order Info',
    title: 'Order Info',
    standAlone: true,
    defaultParameters: [],
    defaultAction: ActionState.EDIT,
    idFieldName: '',
    findForm: new OfbizForm,
    addForm: new OfbizForm({
      local: true,
      formName: "OrderInfo",
      formLocation: "component://kwikstore/widget/OrderViewForms.xml",
      fields: getFields("OrderInfo", ORDR_FORMS),
      targets: getTargets("OrderInfo", ORDR_FORMS),
      titleDescriptionField: "orderTypeId",
      idFieldName: "orderId",
      appContext: "order",
      actionsMenu: [
        {
          title: "Approve Order",
          link: "#",
          icon: "checkmark-circle-2-outline",
          data: {
            target: "",
            appContext: "order",
            parameters: { "orderId": "" },
            condition: <Condition>{
              field: "statusId",
              value: "Created",
              operator: "equals"
            }
          },
        },
        {
          title: "Print Pick Sheet",
          link: "#",
          data: {
            target: "",
            appContext: "order",
            parameters: { "orderId": "" },
            condition: <Condition>{
              field: "statusId",
              value: "Approved",
              operator: "equals"
            }
          },
        },
        {
          title: "Hold Order",
          link: "#",
          icon: "pause-circle-outline",
          data: {
            target: "",
            appContext: "order",
            parameters: { "orderId": "" },
            condition: <Condition>{
              field: "statusId",
              value: "Approved",
              operator: "equals"
            }
          },
        },
        {
          title: "Cancel Order",
          link: "#",
          icon: "close-circle-outline",
          data: {
            target: "",
            appContext: "order",
            parameters: { "orderId": "" },
            condition: <Condition>{
              nestedConditions: [
                {
                  field: "statusId",
                  value: "Approved",
                  operator: "equals"
                },
                {
                  field: "statusId",
                  value: "Created",
                  operator: "equals"
                }
              ],
              combine: 'OR'
            }
          },
        }
      ]
    }),
    addForms: [],
    listForms: [],
    actions: [],
    settings: [],
    summaryView: [],
    lookUpEndPoint: '',
    searchResults: undefined,
    breadCrumbData: {
      displayPrefix: "Product Feature Categories",
      label: "",
      level: 1,
      addFormText: "Create Feature Category",
      editFormText: "Update Feature Category"
    },
    childComponent: null,
    customContainerItems: [],
    lookups: [],
    relations: [],
    appContext: '',
    outGoingLinks: [],
    tasks: [],
    menuAndTitleOptions: undefined,
    getMenuAndTitleOptions: function (): MenuTitleOptions {
      throw new Error('Function not implemented.');
    },
    masterDetails: [],
    selectedMasterDetails: undefined,
    setSelectedMasterDetails: function (selectedMasterDetails: Relation): void {
      throw new Error('Function not implemented.');
    },
    getSelectedMasterDetails: function (): Relation {
      throw new Error('Function not implemented.');
    },
    selectedRelation: undefined,
    selectedTask: undefined
  }

  componentConfig:ComponentConfig;

  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    route:ActivatedRoute,
    router:Router,
    updateComponentStoreService:UpdateComponentStoreService,
    configurationService:ConfigurationService,
    private componentStore:UbsComponentStoreService) { 
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService)
    }

  ngOnInit(): void {
    this.options.addForm.breadCrumbData = {
      selectedValue:{
        "event":"edit",
        "type":"OrderInfo",
        "data":{
          formData:{
            formName:"OrderInfo",
            formLocation:"component://kwikstore/widget/OrderViewForms.xml",
          },
          "endPoint":"catalog",
          "parameters":{"orderId":this.orderId}
        }
      }
    }
    this.componentConfig = new ComponentConfig(this.options);
    console.log(this.componentConfig.addForm.breadCrumbData["selectedValue"]);
    //this.componentStore.updateAction(ActionState.EDIT);
    this.componentStore.updateSelectedValue({
      event:ActionState.EDIT,
      type:"OrderInfo",
      label:"Order Info",
      data:{
        formData: {
          formName: 'OrderInfo',
          formLocation: 'component://kwikstore/widget/OrderViewForms.xml',
        },
        parameters:{"orderId":this.orderId}
      }
    });
    this.hasValue = true;
  }


}
